import { errorsToPropertyErrors, useStickySafeNavigate } from '@equifinance/shared';
import { useState } from 'react';
import { NextPageButton, NextPageContainer } from '../../Buttons/PageButtons';
import { useAccountContext } from '../../../contexts';
import { Stages } from '../../../types/Stages';
import { CreditSearchModal } from '../modals/CreditSearchModal';

export default function NextPage() {
  const {
    account, creditSearchCompleted,
  } = useAccountContext();

  const { id, stage, errors } = account ?? {};

  const navigate = useStickySafeNavigate();

  const [isCreditSeachModalOpen, setIsCreditSeachModalOpen] = useState<boolean>(false);

  const showCreditModal = () => {
    setIsCreditSeachModalOpen(true);
  };

  const hideCreditModal = () => {
    setIsCreditSeachModalOpen(false);
  };

  const onClickNextPage = () => {
    if (stage === Stages.CreditDecision) {
      if (creditSearchCompleted) {
        navigate(`/products/${id}`);
      } else {
        showCreditModal();
      }
    } else {
      navigate(`/credit/${id}`);
    }
  };

  const propertyErrors = errorsToPropertyErrors((Object.values(errors ?? {}) ?? [])?.flat()) ?? {};

  return (
    <>
      {isCreditSeachModalOpen && <CreditSearchModal isOpen={isCreditSeachModalOpen} closeModal={hideCreditModal} />}
      {!creditSearchCompleted && (
        <NextPageContainer>
          <NextPageButton
            onClick={onClickNextPage}
            disabled={
              stage === Stages.CreditDecision
              && Object?.keys(propertyErrors)?.some((propertyError) => !['consentToSearch', 'creditSearch'].includes(propertyError))
            }
          >
            Next page
          </NextPageButton>
        </NextPageContainer>
      )}
    </>
  );
}
